import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";

import { cn } from "@/lib/utils";

// react-day-picker v9 uses: root, day, day_button, caption_label, month_grid,
// month_caption, month, months, nav, button_previous, button_next, week, weeks, weekday, weekdays
function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        root: "rdp-root",
        months: "flex flex-col sm:flex-row gap-4",
        month: "flex flex-col gap-3",
        month_caption: "flex justify-center items-center relative h-9",
        caption_label: "text-sm font-semibold text-center",
        nav: "flex items-center gap-1",
        button_previous: "absolute left-0 h-8 w-8 rounded-md inline-flex items-center justify-center hover:bg-accent text-foreground",
        button_next: "absolute right-0 h-8 w-8 rounded-md inline-flex items-center justify-center hover:bg-accent text-foreground",
        chevron: "h-4 w-4",
        month_grid: "w-full border-collapse table-fixed",
        weekdays: "",
        weekday: "w-8 p-1 font-normal text-[0.8rem] text-muted-foreground text-center",
        weeks: "",
        week: "",
        day: "w-8 h-8 p-0 text-center align-middle",
        // day is the <td>; day_button is the clickable circle inside
        day_button: cn(
          "h-8 w-8 p-0 font-normal rounded-md inline-flex items-center justify-center",
          "hover:bg-accent hover:text-accent-foreground",
          "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        ),
        selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground",
        today: "bg-accent text-accent-foreground",
        outside: "text-muted-foreground opacity-50",
        disabled: "text-muted-foreground opacity-50",
        hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, className: c, ...p }) =>
          orientation === "left" ? (
            <ChevronLeft className={cn("h-4 w-4", c)} {...p} />
          ) : (
            <ChevronRight className={cn("h-4 w-4", c)} {...p} />
          ),
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
